import { RequestStatus, SortOrder } from 'types/enums';
import { FilterId, FilterValue, SortId } from '../enums';

type RefineItem = {
  id: string;
  values: string[];
  title: string;
};

const SORT_ITEMS: RefineItem[] = [
  {
    id: SortId.CREATED_AT,
    values: [SortOrder.ASC, SortOrder.DESC],
    title: 'Sort by created at',
  },
  {
    id: SortId.STATUS,
    values: [RequestStatus.PENDING, RequestStatus.APPROVED, RequestStatus.REJECTED],
    title: 'Sort by status',
  },
];

const FILTER_ITEMS: RefineItem[] = [
  {
    id: FilterId.STATUS,
    values: [FilterValue.OFF, RequestStatus.PENDING, RequestStatus.APPROVED, RequestStatus.REJECTED],
    title: 'Filter by status',
  },
];

export { SORT_ITEMS, FILTER_ITEMS };
